import React, { useEffect, useState, useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, PerspectiveCamera, Text } from '@react-three/drei';
import * as THREE from 'three';
import SponsortsBar from '../../structural/screen/sponsorsBar';
import SponsorBarMobile from '../../structural/screen/sponsorsBarMobile';

const blockTypes = 
[
  {
    id: 1,
    type: 'LADRILLO',
    traba: 2,
    brand: "DOLMEN",
    name: "LADRILLO EXP 07X20X41 ROJO RAYADO",
    width: 0.07, // meters
    height: 0.20, //meters
    length: 0.41, // meters
    weight: 5.76, //kilograms
    price: 1.19, // precio por unidad
    color: "#b85a4a",
    img: ""
  },

  {
    id: 2,
    type: 'traba',
    traba: null,
    brand: "DOLMEN",
    name: "LADRILLO EXP 07X20X20 ROJO RAYADO (TRABA)",
    width: 0.07, //meters
    height: 0.20, //meters
    length: 0.20, //meters
    weight: 3.95, //kilograms
    price: 0.6, // precio por unidad
    color: "#b85a4a",
    img: null
  },

  {
    id: 3,
    type: 'LADRILLO',
    traba: 4,
    brand: "DOLMEN",
    name: "LADRILLO EXP 07X30X41 ROJO RAYADO",
    width: 0.07, // meters
    height: 0.30, //meters
    length: 0.41, // meters
    weight: 7.9, //kilograms
    price: 1.19, // precio por unidad
    color: "#b85a4a",
    img: ""
  },

  {
    id: 4,
    type: 'traba',
    traba: null,
    brand: "DOLMEN",
    name: "LADRILLO EXP 07X30X20 ROJO RAYADO (TRABA)",
    width: 0.07, //meters
    height: 0.30, //meters
    length: 0.20, //meters
    weight: 4.65, //kilograms
    price: 0.6, // precio por unidad
    color: "#b85a4a",
    img: null
  },

  {
    id: 5,
    type: 'LADRILLO',
    traba: 6,
    brand: "DOLMEN",
    name: "LADRILLO EXP 09X30X41 ROJO RAYADO",
    width: 0.09, // meters
    height: 0.30, //meters
    length: 0.41, // meters
    weight: 9.30, //kilograms
    price: 1.19, // precio por unidad
    color: "#b85a4a",
    img: ""
  },

  {
    id: 6,
    type: 'traba',
    traba: null,
    brand: "DOLMEN",
    name: "LADRILLO EXP 09X30X20 ROJO RAYADO (TRABA)",
    width: 0.09, //meters
    height: 0.30, //meters
    length: 0.20, //meters
    weight: 4.65, //kilograms
    price: 0.6, // precio por unidad
    color: "#b85a4a",
    img: null
  },

  {
    id: 7,
    type: 'LADRILLO',
    traba: 8,
    brand: "DOLMEN",
    name: "LADRILLO EXP 10X20X41 ROJO RAYADO",
    width: 0.10, // meters
    height: 0.20, //meters
    length: 0.41, // meters
    weight: 8.30, //kilograms
    price: 1.19, // precio por unidad
    color: "#b85a4a",
    img: ""
  },

  {
    id: 8,
    type: 'traba',
    traba: null,
    brand: "DOLMEN",
    name: "LADRILLO EXP 10X20X20 ROJO RAYADO (TRABA)",
    width: 0.10, //meters
    height: 0.20, //meters
    length: 0.20, //meters
    weight: 4.15, //kilograms
    price: 0.6, // precio por unidad
    color: "#b85a4a",
    img: null
  },

  {
    id: 9,
    type: 'LADRILLO',
    traba: 10,
    brand: "DOLMEN",
    name: "LADRILLO EXP 14X30X41 ROJO RAYADO",
    width: 0.14, // meters
    height: 0.30, //meters
    length: 0.41, // meters
    weight: 12.50, //kilograms
    price: 1.19, // precio por unidad
    color: "#b85a4a",
    img: ""
  },

  {
    id: 10,
    type: 'traba',
    traba: null,
    brand: "DOLMEN",
    name: "LADRILLO EXP 14X30X20 ROJO RAYADO (TRABA)",
    width: 0.14, //meters
    height: 0.30, //meters
    length: 0.20, //meters
    weight: 6.25, //kilograms
    price: 0.6, // precio por unidad
    color: "#b85a4a",
    img: null
  },

  {
    id: 11,
    type: 'LADRILLO',
    traba: 12,
    brand: "DOLMEN",
    name: "LADRILLO EXP 20X20X41 ROJO RAYADO",
    width: 0.20, // meters
    height: 0.20, //meters
    length: 0.41, // meters
    weight: 13.60, //kilograms
    price: 1.19, // precio por unidad
    color: "#b85a4a",
    img: ""
  },

  {
    id: 12,
    type: 'traba',
    traba: null,
    brand: "DOLMEN",
    name: "LADRILLO EXP 20X20X20 ROJO RAYADO (TRABA)",
    width: 0.20, //meters
    height: 0.20, //meters
    length: 0.20, //meters
    weight: 6.80, //kilograms
    price: 0.6, // precio por unidad
    color: "#b85a4a",
    img: null
  },
];

const mortarDensity = 1.6;
const mortarPrice = 120; // precio por m³

const BrickWall = () => 
{  
  // Código del sistema de menú
  const [openMenu, setOpenMenu] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [hasTrabas, setHasTrabas] = useState(false);
  
  const menuRef = useRef();

  const [wallDimensions, setWallDimensions] = useState(
  {
    length: 3.45,
    height: 2.30
  });

  const [mortarGap, setMortarGap] = useState(1); // 1 cm por defecto
  const [selectedBlock, setSelectedBlock] = useState(blockTypes[0]);
  const [results, setResults] = useState(
  {
    fullBlocks: 0,
    fullTrabas: 0,
    cutBlocks: [],
    mortar: 0,
    totalWeight: 0,
    weightPerMeter: 0,
    wallArea: 0,
    blocksCost: 0,
    trabasCost: 0,
    mortarCost: 0,
    totalCost: 0
  });

  // Obtener la traba asociada al LADRILLO seleccionado
  const getTrabaForBlock = (selected) => 
  {
    if (!selected.traba) 
    {
      let halfBlock = 
      {
        length: selected.length/2,
        weight: selected.weight/2,
        price: selected.price/2
      }
      setHasTrabas(false);
      return halfBlock;
    } 
    else 
    {
      setHasTrabas(true);
      return blockTypes.find(b => b.id === selectedBlock.traba);
    }
  };

  useEffect(() => 
  {
    calculateMaterials();
  }, [wallDimensions, selectedBlock, mortarGap]);

  const calculateMaterials = () => 
  {
    const { length, height } = wallDimensions;
    const { length: blockL, height: blockH, width: thickness, weight, price } = selectedBlock;
    const traba = getTrabaForBlock(selectedBlock);
    const trabaL = traba ? traba.length : 0;
    const mortarGapMeters = mortarGap / 100; // Convertir cm a metros

    let fullBlocks = 0;
    let fullTrabas = 0;
    const cutBlocks = [];
    let currentY = 0;
    let rowCounter = 0;
    let totalMortarX = 0;
    let totalMortarY = 0;
    let totalRows = 0;

    // Área total de la pared
    const wallArea = length * height;

    // Calcular filas
    while (currentY < height) {
      const rowHeight = Math.min(blockH, height - currentY);
      const isOddRow = rowCounter % 2 !== 0;
      let currentX = 0;
      let blocksInRow = 0;
      let lastBlockWasTraba = false;
      
      // Calcular LADRILLOs en esta fila
      while (currentX < length) {
        const remainingX = length - currentX;
        let blockSizeX = blockL;
        let isTraba = false;
        
        // En filas impares, colocar traba al inicio si existe y cabe
        if (isOddRow && traba && blocksInRow === 0 && remainingX >= trabaL && !lastBlockWasTraba) {
          blockSizeX = trabaL;
          isTraba = true;
          lastBlockWasTraba = true;
        } 
        // Si es un LADRILLO cortado, decidir si cortar LADRILLO o traba
        else if (remainingX < blockL) {
          if (traba && remainingX >= trabaL && !lastBlockWasTraba) {
            blockSizeX = trabaL;
            isTraba = true;
            lastBlockWasTraba = true;
          } else {
            blockSizeX = remainingX;
            lastBlockWasTraba = false;
          }
        } else {
          lastBlockWasTraba = false;
        }

        if (blockSizeX > 0.01) {
          if (Math.abs(blockSizeX - (isTraba ? trabaL : blockL)) < 0.001 && 
              Math.abs(rowHeight - blockH) < 0.001) {
            if (isTraba) {
              fullTrabas++;
            } else {
              fullBlocks++;
            }
          } else {
            cutBlocks.push({
              width: thickness,
              height: rowHeight,
              length: blockSizeX,
              isTraba
            });
          }
          blocksInRow++;
          currentX += blockSizeX;
          
          // Añadir mortero vertical excepto después del último LADRILLO
          if (currentX < length) {
            totalMortarX += thickness * rowHeight * mortarGapMeters;
            currentX += mortarGapMeters;
          }
        } else {
          break;
        }
      }
      
      currentY += rowHeight;
      totalRows++;
      
      // Añadir mortero horizontal excepto después de la última fila
      if (currentY < height) {
        totalMortarY += length * thickness * mortarGapMeters;
        currentY += mortarGapMeters;
      }
      
      rowCounter++;
    }

    // Calcular mortero total (incluyendo bordes)
    const verticalMortar = totalMortarX + (thickness * height * mortarGapMeters * 2); // bordes izquierdo y derecho
    const horizontalMortar = totalMortarY + (length * thickness * mortarGapMeters * 2); // bordes superior e inferior
    const mortar = verticalMortar + horizontalMortar;

    // Calcular costos
    const cutBlocksWeight = cutBlocks.reduce((sum, block) => {
      const blockWeight = block.isTraba ? traba.weight : weight;
      const blockFullLength = block.isTraba ? trabaL : blockL;
      return sum + (block.width * block.height * thickness * blockWeight / (blockFullLength * blockH * thickness));
    }, 0);

    const totalWeight = (fullBlocks * weight) + (fullTrabas * (traba ? traba.weight : 0)) + cutBlocksWeight + (mortar * mortarDensity * 1000);

    // Calcular costos
    const blocksCost = fullBlocks * price;
    const trabasCost = fullTrabas * (traba ? traba.price : 0);
    const mortarCost = mortar * mortarPrice;
    const totalCost = blocksCost + trabasCost + mortarCost;

    setResults({
      fullBlocks,
      fullTrabas,
      cutBlocks,
      mortar,
      totalWeight,
      weightPerMeter: totalWeight / length,
      verticalMortar,
      horizontalMortar,
      wallArea,
      blocksCost,
      trabasCost,
      mortarCost,
      totalCost
    });
  };

  const handleDimensionChange = (e) => 
  {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;
    const roundedValue = Math.max(0.05, Math.round(numericValue * 20) / 20);
    setWallDimensions(prev => ({
      ...prev,
      [name]: roundedValue
    }));
  };

  const handleMortarGapChange = (e) =>
  {
    const value = parseFloat(e.target.value) || 0;
    // Redondear al múltiplo de 0.5 más cercano
    const roundedValue = Math.round(value * 2) / 2;
    // Asegurar que esté entre 0.5 y 5 cm
    const clampedValue = Math.max(0.5, Math.min(5, roundedValue));
    setMortarGap(clampedValue);
  };

  const formatDimension = (value) => 
  {
    const cmValue = Math.round(value * 100);
    return cmValue % 1 === 0 ? cmValue : cmValue.toFixed(1);
  };

  const formatCurrency = (value) => 
  {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'USD' }).format(value);
  };

  const renderCutBlocks = () => 
  {
    const counts = {};
    results.cutBlocks.forEach(block => 
    {
      const type = block.isTraba ? 'Traba' : 'LADRILLO';
      const key = `${type} ${formatDimension(block.width)}x${formatDimension(block.height)}x${formatDimension(block.length)}`;
      counts[key] = (counts[key] || 0) + 1;
    });

    return Object.entries(counts).map(([size, count]) => (
      <p key={size} className="text-sm">
        <span className="font-semibold">{size} cm:</span> {count}
      </p>
    ));
  };

  // Filtrar solo LADRILLOs (no trabas) para el dropdown
  const availableBlocks = blockTypes.filter(block => block.type === 'LADRILLO');

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  useEffect(() => 
  {
    const handleClickOutside = (event) => 
    {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => 
  {
    const handleResize = () => 
    {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) 
        {
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className = "flex flex-col h-screen">
      
      {/* MENÚ SUPERIOR */}
      <div ref={menuRef} className="bg-gray-800 text-white flex justify-between items-center px-4 py-2 z-[3000]">
        <div className = "bg-gray-800 text-white flex justify-between items-center px-4 py-2 z-[3000] h-[40px]">        
          
          
          {/* Créditos - Enlaces externos */}
          <div className="relative">
            <button 
              className="hover:bg-gray-600 px-3 py-1 rounded bg-gray-700"
              onClick={() => toggleMenu('creditos')}
            >
              Créditos
            </button>
            <div className={`absolute left-0 mt-1 ${openMenu === 'creditos' ? 'block' : 'hidden'} bg-white text-black rounded shadow w-[300px]`}>
              <a 
                href="https://www.linkedin.com/in/entornoceo/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block font-bold text-black px-4 py-2 hover:bg-gray-100 w-full text-left cursor-pointer"
              >
                Creado por: Ing. Javier Hernández
              </a>             
            </div>
          </div>
          
        </div>
        <div>
          <span className="font-bold uppercase">Paredes De Ladrillo Visto</span>
        </div>
      </div>

      {/* CONTENIDO PRINCIPAL */}
      <div className = "flex sm:flex-row flex-col h-full overflow-hidden">
       
        {/* Área de Gráficas / Modelo 3D */}
        <div className = "flex flex-col flex-1 z-50 bg-gray-50 sm:w-9/12 sm:h-full h-1/2">
          
          <div className="flex bg-gray-50 p-1 h-[60px] sm:hidden m-auto">
            <SponsorBarMobile/>
          </div>

          <div className="h-full w-full border-b-2 sm:border-0 border-black	">
            <Canvas>
              <ambientLight intensity={0.5} />
              <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} />
              <PerspectiveCamera makeDefault position={[4, 1, -4]} />
              <OrbitControls enablePan={true} enableZoom={true} enableRotate={true} />
              <Wall3D wall={wallDimensions} block={selectedBlock} mortarGap={mortarGap / 100} />
            </Canvas>
          </div>

          <div className="sm:flex bg-gray-50 p-1 h-[100px] hidden m-auto">
            <SponsortsBar/>
          </div>
        </div>        

        {/* 🔴 Panel Derecho de Inputs */}
        <div className="flex flex-col p-4 bg-gray-200 overflow-y-auto z-50 sm:w-3/12 sm:min-w-[300px] sm:h-full h-1/2">          

          <h2 className="text-xl font-semibold mb-4">Parámetros de la Pared</h2>
              
          <div className="space-y-4">
            {['length', 'height'].map((dim) => (
              <div key={dim}>
                <label className="block text-sm font-medium text-gray-700">
                  {dim === 'length' ? `Longitud${ isMobile ? ` - ${wallDimensions[dim]}` : ''}` : `Altura${ isMobile ? ` - ${wallDimensions[dim]}` : ''}`} (m)
                </label>
                <input
                  type= { isMobile ? "range" : "number"}
                  inputMode="decimal"
                  pattern="[0-9]*"
                  name={dim}
                  value={wallDimensions[dim]}
                  onChange={handleDimensionChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
                  min="1"
                  max = { dim === 'length' ? isMobile ? 10 : 20 : isMobile ? 5 : 10 }
                  step="0.05"
                />
                <p className="text-xs text-gray-500">{`Incrementos de 5 cm (mínimo 1 metro - máximo ${dim === 'length' ? isMobile ? 10 : 20 : isMobile ? 5 : 10}) metros`}</p>
              </div>
            ))}

            <div>
              <label className="block text-sm font-medium text-gray-700">
                {`Espesor de mortero${ isMobile ? ` - ${mortarGap}` : ''} (cm)`}
              </label>
              <input
                type= { isMobile ? "range" : "number"}
                inputMode="decimal"
                pattern="[0-9]*"
                value={mortarGap}
                onChange={handleMortarGapChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
                min="0.5"
                max="5"
                step="0.5"
              />
              <p className="text-xs text-gray-500">Incrementos de 0.5 cm (mínimo 0.5 cm, máximo 5 cm)</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Tipo de LADRILLO</label>
              <select
                value={selectedBlock.id}
                onChange={(e) => setSelectedBlock(blockTypes.find(b => b.id === parseInt(e.target.value)))}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
              >
                {availableBlocks.map(block => (
                  <option key={block.id} value={block.id}>{block.brand} - {block.name}</option>
                ))}
              </select>
            </div>
          </div>

          <h3 className="text-lg font-medium my-3">Resultados</h3>

          <div className="space-y-2 mb-4">
            <p><span className="font-semibold">Área de la pared:</span> {results.wallArea.toFixed(2)} m²</p>
            
            <h4 className="font-semibold mt-2 uppercase underline">Materiales:</h4>
            <p><span className="font-semibold">LADRILLOs completos:</span> {results.fullBlocks}</p>
            
            {results.fullTrabas > 0 && hasTrabas && (
              <p><span className="font-semibold">Trabas completas:</span> {results.fullTrabas}</p>
            )}

            <h4 className="font-semibold mt-2"> {hasTrabas ? "Ladrillos/Trabas cortados:" : "Bloques cortados:"} </h4>
            {results.fullTrabas > 0 && !hasTrabas && (
              <p><span className="font-semibold">Medios Ladrillos:</span> {results.fullTrabas}</p>
            )}
            
            <h4 className="font-semibold mt-2">LADRILLOs/Trabas cortados:</h4>
            {results.cutBlocks.length > 0 ? renderCutBlocks() : <p className="text-sm">No hay LADRILLOs/trabas cortados</p>}
            
            <h4 className="font-semibold mt-2 uppercase underline">Mortero:</h4>
            <p className="text-sm"><span className="font-semibold">Volumen total:</span> {results.mortar.toFixed(3)} m³</p>
            <p className="text-sm"><span className="font-semibold">Mortero vertical:</span> {results.verticalMortar?.toFixed(3) || '0.000'} m³</p>
            <p className="text-sm"><span className="font-semibold">Mortero horizontal:</span> {results.horizontalMortar?.toFixed(3) || '0.000'} m³</p>
            
            <h4 className="font-semibold mt-2 uppercase underline">Pesos:</h4>
            <p className="text-sm"><span className="font-semibold">Peso total:</span> {results.totalWeight.toFixed(0)} kg</p>
            <p className="text-sm"><span className="font-semibold">Peso por metro lineal:</span> {results.weightPerMeter.toFixed(0)} kg/m</p>
            
            <h4 className="font-semibold mt-2 uppercase underline">Costos:</h4>
            <p className="text-sm"><span className="font-semibold">Costo LADRILLOs:</span> {formatCurrency(results.blocksCost)}</p>
            {results.fullTrabas > 0 && (
              <p className="text-sm"><span className="font-semibold">Costo trabas:</span> {formatCurrency(results.trabasCost)}</p>
            )}
            <p className="text-sm"><span className="font-semibold">Costo mortero:</span> {formatCurrency(results.mortarCost)}</p>
            <p className="text-sm"><span className="font-semibold">Costo total:</span> {formatCurrency(results.totalCost)}</p>
          </div>

        </div>
      </div>

    </div>
  );
};

const Wall3D = ({ wall, block, mortarGap }) => 
{
  const { length, height } = wall;
  const { length: blockL, height: blockH, width: thickness, color, traba } = block;
  const trabaData = blockTypes.find(b => b.id === traba);

  const lengthTextRef = useRef();
  const heightTextRef = useRef();

  useFrame(({ camera }) => 
  {
    if (lengthTextRef.current) lengthTextRef.current.lookAt(camera.position);
    if (heightTextRef.current) heightTextRef.current.lookAt(camera.position);
  });

  const blocks = [];
  let currentY = -height/2;
  let rowCounter = 0;

  // Mortero inferior
  blocks.push(
    <mesh
      key="mortar-bottom"
      position={[0, -height/2 - mortarGap/2, 0]}
    >
      <boxGeometry args={[length + mortarGap*2, mortarGap, thickness]} />
      <meshStandardMaterial color="#cccccc" />
    </mesh>
  );

  // Mortero izquierdo
  blocks.push(
    <mesh
      key="mortar-left"
      position={[-length/2 - mortarGap/2, 0, 0]}
    >
      <boxGeometry args={[mortarGap, height + mortarGap*2, thickness]} />
      <meshStandardMaterial color="#cccccc" />
    </mesh>
  );

  // Mortero derecho
  blocks.push(
    <mesh
      key="mortar-right"
      position={[length/2 + mortarGap/2, 0, 0]}
    >
      <boxGeometry args={[mortarGap, height + mortarGap*2, thickness]} />
      <meshStandardMaterial color="#cccccc" />
    </mesh>
  );  

  // Mortero superior
  blocks.push(
    <mesh
      key="mortar-top"
      position={[0, height/2 + mortarGap/2, 0]}
    >
      <boxGeometry args={[length + mortarGap*2, mortarGap, thickness]} />
      <meshStandardMaterial color="#cccccc" />
    </mesh>
  );

  // Ladrillos
  while (currentY < height/2) 
  {
    const rowHeight = Math.min(blockH, height/2 - currentY);
    if (rowHeight <= 0) break;

    let currentX = -length/2;
    const isOddRow = rowCounter % 2 !== 0;
    let blocksInRow = 0;
    let lastBlockWasTraba = false;
    
    while (currentX < length/2) 
    {
      const remainingX = length/2 - currentX;
      let blockSizeX = blockL;
      let blockColor = color;
      let isTraba = false;
      
      // Lógica para colocar traba solo al inicio de filas impares
      if (isOddRow && trabaData && blocksInRow === 0 && remainingX >= trabaData.length) {
        blockSizeX = trabaData.length;
        blockColor = trabaData.color;
        isTraba = true;
      } 
      // Manejo especial para el FINAL de la fila (lado derecho)
      else if (remainingX < blockL) {
        // NUNCA colocar traba al final si va a quedar sola
        // Siempre preferir un LADRILLO cortado al final
        blockSizeX = remainingX;
        
        // Solo en casos muy específicos donde el corte coincide exactamente con tamaño de traba
        if (trabaData && Math.abs(remainingX - trabaData.length) < 0.001) {
          blockSizeX = trabaData.length;
          blockColor = trabaData.color;
          isTraba = true;
        }
      }
    
      // Ajuste final para no sobrepasar el borde
      if (currentX + blockSizeX > length/2) {
        blockSizeX = length/2 - currentX;
      }
    
      if (blockSizeX > 0.01)
      {
        blocks.push(
          <group key={`${currentY}-${currentX}`}>
            <mesh
              position={[currentX + blockSizeX/2, currentY + rowHeight/2, 0]}
            >
              <boxGeometry args={[blockSizeX, rowHeight, thickness]} />
              <meshStandardMaterial color={blockColor} />
            </mesh>
            <lineSegments position={[currentX + blockSizeX/2, currentY + rowHeight/2, 0]}>
              <edgesGeometry args={[new THREE.BoxGeometry(blockSizeX, rowHeight, thickness)]} />
              <lineBasicMaterial color="#111111" linewidth={2} />
            </lineSegments>
          </group>
        );
    
        currentX += blockSizeX;
        blocksInRow++;
        
        // Añadir mortero excepto después del último LADRILLO
        if (currentX < length/2) {
          blocks.push(
            <mesh
              key={`mortar-${currentY}-${currentX}`}
              position={[currentX + mortarGap/2, currentY + rowHeight/2, 0]}
            >
              <boxGeometry args={[mortarGap, rowHeight, thickness]} />
              <meshStandardMaterial color="#cccccc" />
            </mesh>
          );
          currentX += mortarGap;
        }
      } else {
        break;
      }
    }
    
    currentY += rowHeight;
    
    // Añadir mortero horizontal excepto después de la última fila
    if (currentY < height/2)
    {
      // Visualización del mortero horizontal
      blocks.push(
        <mesh
          key={`mortar-h-${currentY}`}
          position={[0, currentY + mortarGap/2, 0]}
        >
          <boxGeometry args={[length, mortarGap, thickness]} />
          <meshStandardMaterial color="#cccccc" />
        </mesh>
      );
      currentY += mortarGap;
    }
    
    rowCounter++;
  }

  return (
    <group>
      <group ref={lengthTextRef} position={[0, -height/2 - mortarGap - 0.15, 0]}>
        <Text color="black" anchorX="center" anchorY="middle" fontSize={0.1}>
          {length.toFixed(2)} m
        </Text>
      </group>
      
      <group ref={heightTextRef} position={[-length/2 - mortarGap - 0.15, 0, 0]}>
        <Text 
          color="black" 
          anchorX="center" 
          anchorY="middle" 
          fontSize={0.1}
          rotation={[0, 0, Math.PI/2]}
        >
          {height.toFixed(2)} m
        </Text>
      </group>
      
      {blocks}
    </group>
  );
};

export default BrickWall;